/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Cancelled_Title1Inputs */

const en_coinvestments_report_cancelled_title1 = /** @type {(inputs: Coinvestments_Report_Cancelled_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal was cancelled`)
};

/**
* | output |
* | --- |
* | "This deal was cancelled" |
*
* @param {Coinvestments_Report_Cancelled_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_cancelled_title1 = /** @type {((inputs?: Coinvestments_Report_Cancelled_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Cancelled_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_cancelled_title1(inputs)
});
export { coinvestments_report_cancelled_title1 as "coInvestments_report_cancelled_title" }